export const fetchHomeownerImprovementFixing = (unitId: string) => ({
  promise: ({ client }: { client: any }) =>
    client.get(`/homeowners/units/${unitId}/homeowner-fixing`),
});
